import {
    comMapping
} from "@/components/util/Function/comMapping";

export function getdata() {
    var obj = {
        searchlist: [
            {
                prop: "businessMatchStatus",
                label: '处理状态',
                type: "select",
                selectval: comMapping.$businessMatchStatus
            },
            {
                prop: "zhuanyjkshm",
                label: '海关缴款书号',
                type: "input"
            },
            {
                prop: "accountCode",
                label: '科目代码',
                type: "input"
            },
            {
                prop: "voucherDesc",
                label: '凭证摘要',
                type: "input"
            },
            {
                prop: "postingDate",
                label: '记账日期',
                type: "date",
                valueformat: 'yyyy-MM-dd'
            },
            {
                prop: "companyCode",
                label: '公司代码',
                type: "selectmore",
                width: "220px",
            },
            {
                prop: "voucherNo",
                label: '凭证号',
                type: "input"
            },
            {
                prop: "voucherDate",
                label: '凭证日期',
                type: "date",
                valueformat: 'yyyy-MM-dd'
            },
            {
                prop: "billingNo",
                label: 'billing号',
                type: "input"
            },
        ],
        searchdata: {
            businessMatchStatus: "",
            zhuanyjkshm: "",
            accountCode: "",
            voucherDesc: "",
            postingDate: [],
            companyCode: [],
            voucherNo: "",
            voucherDate: [],
            billingNo: "",
        },
        headData: [
            {
                title: "公司代码",
                prop: "companyCode",
                width: "80",
                custom: true
            },
            {
                title: "所属期",
                prop: "suosq",
                width: "80",
                custom: true
            },
            {
                title: "海关缴款书号",
                prop: "zhuanyjkshm",
                width: "170",
                custom: true
            },
            {
                title: "备注",
                prop: "businessMatchRemark",
                width: "110",
                custom: true
            },
            {
                title: "税款金额",
                prop: "shuikje",
                width: "110",
                custom: true
            },
            {
                title: "有效抵扣税额",
                prop: "yxdkse",
                width: "110",
                custom: true
            },
            {
                title: "认证方式",
                prop: "renzyt",
                width: "100",
                custom: true
            },
            {
                title: "凭证金额",
                prop: "localAmount",
                width: "110",
                custom: true
            },
            {
                title: "业务类型",
                custom: true,
                prop: "businessType",
                width: 100,
            },
            {
                title: "处理状态",
                custom: true,
                prop: "businessMatchStatus",
                width: 100,
            },
            {
                title: "科目代码",
                prop: "accountCode",
                width: "110",
                custom: true
            },
            {
                title: "凭证号",
                custom: true,
                prop: "voucherNo",
                width: 110,
            },
            {
                custom: true,
                title: "记账日期",
                prop: "postingDate",
                width: 110,
            },
            {
                custom: true,
                title: "凭证日期",
                prop: "voucherDate",
                width: 110,
            },
            {
                title: "凭证摘要",
                custom: true,
                prop: "voucherDesc",
                width: 110,
            },
            {
                title: "billing号",
                custom: true,
                prop: "billingNo",
                width: 100,
            },
            {
                title: "参考字段一",
                custom: true,
                prop: "cank1",
                width: 100,
            },
            {
                title: "参考字段二",
                custom: true,
                prop: "cank2",
                width: 100,
            },
            {
                title: "参考字段三",
                custom: true,
                prop: "cank3",
                width: 100,
            },
            {
                title: "参考字段四",
                custom: true,
                prop: "cank4",
                width: 100,
            },
        ],
        pagination: {
            pageNum: 1,
            pageSize: 50,
            total: 0,
            paginationkey: 0
        }
    }
    return obj
}
